<!--
// app/pages/[region]/Tickets.vue
-->
<script setup lang="ts">
import HeaderBannerTitle from "~/app/components/Shared/HeaderBannerTitle.vue";
import HubSpotForm from "~/app/components/pages/region-tickets/HubSpotForm.vue";
import { useWebContext } from "~/app/composables/webContext";
import ticketsBlocksUiService from "~/src/content/infrastructure/ui-services/ticketsBlockUiService";

const { t, locale } = useI18n();
const { contextSiteTitle, isKings, isQueens } = useWebContext();
const { getTicketsBlocks } = ticketsBlocksUiService();

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: "/[region]/tickets",
    es: "/[region]/entradas",
    de: "/[region]/tickets",
    fr: "/[region]/billetterie",
    it: "/[region]/biglietti",
    pt: "/[region]/ingressos",
  },
});

const blocks = await getTicketsBlocks(locale.value);

const kingsFormId =
  locale.value === "es" ? "71af8cbc-f6d3-45b5-8773-eb9f9b678fd2" : "1fc80371-2a29-47a5-b8f5-d89cc428504d";
const queensFormId =
  locale.value === "es" ? "925d7b31-835f-4785-9995-daa18f8ae0ae" : "6028354b-69aa-47d5-be55-31cb18cd6141";

definePageMeta({
  middleware: [
    "not-found-americas",
    "not-found-world-cup",
    "not-found-italy",
    "not-found-queens-americas",
    "not-found-nations",
    "not-found-king-of-kings-nations",
    "not-found-brazil",
    "not-found-france",
    "not-found-germany",
    "not-found-mena",
  ],
});

useSeoMeta({
  title: t("header.tickets"),
  ogTitle: t("header.tickets"),
});
</script>

<template>
  <header-banner-title :title="$t('header.tickets')"></header-banner-title>

  <section class="px-4 pt-5 pb-16 lg:py-16 kql-tickets">
    <div v-if="blocks && blocks.length">
      <div v-for="block in blocks" class="kql-w-container box-content-block mb-8">
        <NuxtImg
          v-if="block.image"
          :src="block.image"
          :alt="block.title"
          class="w-full h-full max-h-96 md:max-h-none object-cover object-center"
          width="500"
          height="500"
        />
        <div :class="['box-content-text', { '!px-4 !col-span-2': !block.image }]">
          <h2 class="box-content-title" v-html="block.title"></h2>
          <div class="box-text-block mb-6 md:mb-10" v-html="block.description"></div>
          <a :href="block.link" target="_blank" class="btn btn-emphasis text-sm">{{ block.buttonText }}</a>
        </div>
      </div>
    </div>

    <div class="kql-w-container box-content-standard">
      <div class="w-full">
        <NuxtImg
          src="/img/tickets/cupra-arena.jpg"
          alt="CUPRA Arena"
          class="w-full h-auto rounded-lg"
          width="800"
          height="552"
          sizes="256px sm:960px md:670px"
        />
      </div>
      <div class="box-content-text">
        <i18n-t keypath="tickets.experienceLeague.title" tag="h2" class="box-content-title">
          <template #league>
            <span>{{ contextSiteTitle }}</span>
          </template>
        </i18n-t>

        <p class="box-text mb-5">{{ $t("tickets.stadiumTickets.text") }}</p>

        <HubSpotForm :formId="isKings ? kingsFormId : queensFormId" src="//js.hsforms.net/forms/shell.js" />
      </div>
    </div>
  </section>
</template>

<style scoped></style>
